module.exports = __webpack_public_path__ + "img/img2.691e3c56.png";